import { render } from "./ProposalNoAccess.vue?vue&type=template&id=a61e0260&scoped=true"
import script from "./ProposalNoAccess.vue?vue&type=script&lang=js"
export * from "./ProposalNoAccess.vue?vue&type=script&lang=js"

import "./ProposalNoAccess.vue?vue&type=style&index=0&id=a61e0260&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61e0260"]])

export default __exports__